module.exports = __webpack_public_path__ + "media/country_flags/vg-085d1e0d.png";